import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

import { PageInterface } from 'src/app/workflow/planner/page/page.interface';
import { Router } from '@angular/router';
import { ShiftRecordStatus } from 'src/shared/models/shift-record-status';
import { AncillaryWorkflowPage } from 'src/shared/models/workflow-page-ancllary.model';
import { WorkflowPageComponent } from 'src/app/workflow/base-classes/workflow-page/workflow-page.component';
import { TotalUOSShiftRecordService } from 'src/shared/services/shift-record-total-uos.service';
import { WorkflowUtilityService } from 'src/shared/services/workflow-utility.service';
import { ShiftRecord } from 'src/shared/models/shift-record.model';
import { UnitOfServiceRecord } from 'src/shared/models/unit-of-service-record.model';
import { WorkflowConstants } from 'src/app/workflow/workflow-constants.util';
import { Constants } from 'src/shared/utilities/constants.util';
import { ImportTotalUosModalComponent } from '../../import-total-uos-modal/import-total-uos-modal.component';
import { WorkflowPageUtil } from '../../base-classes/workflow-page/workflow-page.util';
import { HsgModal } from '@hhsg/hsg-asc';
import { UnitOfServiceRecordService } from 'src/shared/services/uos-record.service';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';
import { distinctUntilChanged } from 'rxjs/internal/operators/distinctUntilChanged';
import { MiscUtil } from 'src/shared/utilities/misc.util';

@Component({
    selector: 'smt-review-previous-uos',
    templateUrl: './review-previous-uos.component.html',
    styleUrls: ['./review-previous-uos.component.scss']
})
export class TotalUOSReviewPreviousByBlockComponent extends WorkflowPageComponent implements OnInit, PageInterface {
    @Input() page: AncillaryWorkflowPage;
    @Output() previousRequested = new EventEmitter();

    public totalUOSForm = new UntypedFormGroup({});
    public acuityFormValues$;
    public formGroups: UntypedFormGroup[];
    private minValue = WorkflowConstants.UosMinValue;
    private maxValue = WorkflowConstants.UosMaxValue;
    public projectedTotalUosRecord: UnitOfServiceRecord;
    public actualTotalUosRecord: UnitOfServiceRecord;
    public prevShiftRecord: ShiftRecord;
    public addOnsPercentage = 0;
    private hasImportedDataValues: boolean;
    private editingImportedRecords: boolean;
    private importedValueChanged: boolean;
    private importedAmount: number = 0;
    public totalUOSFormValues$;
    private validators = [Validators.required, Validators.min(this.minValue), Validators.max(this.maxValue), Validators.pattern(Constants.NoDecimalRegex)];
    public loadingRecords: boolean;

    private actualUosControlName = 'actualUos';
    private reviewedControlName = 'reviewed';

    get unitOfServiceName(): string {
        return this.page.unitOfServiceName;
    }

    constructor(private _router: Router,
        private _totalUOSShiftRecordService: TotalUOSShiftRecordService,
        private _utility: WorkflowUtilityService,
        private _uosRecordService: UnitOfServiceRecordService,
        private _modal: HsgModal) {
        super(_router);
    }

    ngOnInit() {
        this.loadingRecords = true;
        super.initialize(this.page, () => this.initialize());
        this.loadingRecords = false;
    }

    async initialize() {
        this.prevShiftRecord = this.shiftRecord.prevShiftRecord;
        this.hasImportedDataValues = false;
        this.editingImportedRecords = false;

        let actualUosValue = '';
        if (this.prevShiftRecord) {
            // calculate the % of AddOns from the Cost Center Config.
            this.addOnsPercentage = this.prevShiftRecord.shiftBlock.addOns / 100;
            this.projectedTotalUosRecord = this.prevShiftRecord.unitOfServiceRecords.find(uos => uos.isProjected);
            this.actualTotalUosRecord = this.prevShiftRecord.unitOfServiceRecords.find(uos => !uos.isProjected);

            if (this.actualTotalUosRecord) {
                actualUosValue = this.actualTotalUosRecord.total.toString();
            }
            let control = new UntypedFormControl(actualUosValue, this.validators);
            // If there was no previous shift, do not add the form control so the next button will be enabled
            this.totalUOSForm.addControl(this.actualUosControlName, control);
            control.valueChanges
            // There is a bug in angular that causes valueChanges subscriptions to fire twice for number inputs.
            // distinctUntilChanged is an rxjs operator that can be used as a work around until SMT is upgraded
            // to a version of angular where this bug is corrected.
            .pipe(distinctUntilChanged())
            .pipe(debounceTime(Constants.DebounceTime))
            .subscribe(value => {
                if (MiscUtil.isValidNonNegativeNumber(value)) {
                    let checkBoxControl = this.totalUOSForm.get(this.reviewedControlName);
                     if(this.importedAmount != value)                            {
                        checkBoxControl.disable();
                        this.importedValueChanged = true;
                     }
                     else {
                        checkBoxControl.enable();
                        this.importedValueChanged = false;
                     }
                }
                else {

                }
            });
            this.initialzeImportedData();
        }

        this.disableActualControlIfNotProjectedRecord();
        this.formGroups = [this.totalUOSForm];
    }

    async initialzeImportedData() {
        this.importedValueChanged = false;
        let workflowDates = [];
        workflowDates.push(this.prevShiftRecord.workflowTimeFacility);
        let actualTotalUosRecordWithImported = await this._uosRecordService.getUnitOfServiceRecordsForAncillaryPatient(this.shiftRecord.costCenterId, workflowDates) || [];
        let foundImported = actualTotalUosRecordWithImported.find(x=> x.importedAmount && x.importedAmount >0);
        if(foundImported){
            this.totalUOSForm.addControl(this.reviewedControlName, new UntypedFormControl(false,Validators.requiredTrue));
            let control = this.totalUOSForm.get(this.actualUosControlName);
            if(control.value != foundImported.importedAmount){
                control.setValue(foundImported.importedAmount);
                this.importedAmount = foundImported.importedAmount;
                this.hasImportedDataValues = true;
                control.disable();
            }
        }
    }

    disableActualControlIfNotProjectedRecord()
    {
        if(!this.projectedTotalUosRecord)
        {
            let control = this.totalUOSForm.controls[this.actualUosControlName];

            if (control) {
                control.disable();
            }
        }
    }

    valueOutOfRange(): boolean {
        let control = this.totalUOSForm.get(this.actualUosControlName);
        return control && !control.valid && (control.touched || control.dirty) && (control.errors.min || control.errors.max || control.errors.pattern);
    }

    isFormValid(): boolean {
        return this.totalUOSForm && (this.totalUOSForm.valid || this.importedValueChanged);
    }

    getProjectedUosTotal(): string {
        if (this.projectedTotalUosRecord) {
            return this.projectedTotalUosRecord.total.toString();
        }
        return '*';
    }

    getProjectedScheduledUos(): string {
        if (this.projectedTotalUosRecord) {
            let schedulesValue = this._utility.getSchedulesValue(this.projectedTotalUosRecord.total,this.addOnsPercentage);
            return (schedulesValue).toString();
        }
        return '*';
    }

    async save(): Promise<number> {
        this.setStatus();
        this.setTotalUOS();
        if (!this.shiftRecord.prevShiftRecord) {
            return this._totalUOSShiftRecordService.setShiftRecordWithAssociated(this.shiftRecord);
        }

        return await this._totalUOSShiftRecordService.setShiftRecordWithAssociated(this.prevShiftRecord)
            .then((prevShiftRecordId) => {
                this.shiftRecord.prevShiftRecordId = prevShiftRecordId;
                return this._totalUOSShiftRecordService.setShiftRecordWithAssociated(this.shiftRecord);
            },
                (errors) => { console.error(errors); return 0; });
    }

    shouldSkipSave(): boolean {
        return false;
    }

    private setStatus() {
        if (this.shiftRecord.status !== ShiftRecordStatus.Done && this.page.nextPage) {
            this.shiftRecord.status = this.page.nextPage.completedStatus;
        }
    }

    private setTotalUOS() {
        if (this.prevShiftRecord) {
            let control = this.totalUOSForm.get(this.actualUosControlName);
            if (!this.actualTotalUosRecord) {
                this.actualTotalUosRecord = new UnitOfServiceRecord();
            }
            this.actualTotalUosRecord.isProjected = false;
            this.actualTotalUosRecord.shiftBlockId = this.prevShiftRecord.shiftBlockId;
            this.actualTotalUosRecord.workflowTimeFacility = this.prevShiftRecord.workflowTimeFacility;
            this.actualTotalUosRecord.unitOfServiceId = this.prevShiftRecord.costCenter.ancillaryConfiguration.unitOfServiceId;
            this.actualTotalUosRecord.total = control.value;

            if (!this.prevShiftRecord.unitOfServiceRecords) {
                this.prevShiftRecord.unitOfServiceRecords = [];
            }
            this.prevShiftRecord.unitOfServiceRecords.push(this.actualTotalUosRecord);
        }
    }

    getAddOns(): string {
        if (this.projectedTotalUosRecord) {

            let addOnsValue = this.projectedTotalUosRecord.total - this._utility.getSchedulesValue(this.projectedTotalUosRecord.total,this.addOnsPercentage);
            return (addOnsValue).toString();
        }
        return '*';

    }

    isAddOnsPresent(addOnsValue: number){
        return this._utility.isAddOnsPresent(addOnsValue);
    }

    public openImportedValuesModal() {
        this._modal.open(
            ImportTotalUosModalComponent,
            {
                width: '90%',
                height: '80%',
                data: {
                    title: 'Total UOS Imported Values',
                    shiftBlock: this.prevShiftRecord.shiftBlock,
                    workflowDate: this.prevShiftRecord.workflowTimeFacility,
                    costCenter: this.prevShiftRecord.costCenter,
                    isFirstShiftBlock: this.prevShiftRecord.shiftBlock.previousShiftBlockId == null,
                    isLastShiftBlock: this.page.isLastShiftBlock
                }
            });
    }

    public hasTotalUosImports(): boolean {
        return this.shiftRecord && (WorkflowPageUtil.hasTotalUosImports(this.client, this.shiftRecord.costCenter) || this.hasImportedData());
    }

    public hasImportedData(): boolean {
        return this.actualTotalUosRecord && this.actualTotalUosRecord.importedAmount != null;
    }

    editImported(): void {
        this.editingImportedRecords = !this.editingImportedRecords;

        let control = this.totalUOSForm.get(this.actualUosControlName);
        if(control){
            if (control.enabled) {
                control.setValidators(null);
                control.disable();
                control.markAsUntouched();
                control.markAsPristine();
            }
            else {
                control.setValidators(this.validators);
                control.enable();
            }
        }
    }
}
